import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import 'material-icons/iconfont/filled.css'
import ReactGA from 'react-ga4'

import Card from '@components/card'
import PrimaryButton from '@components/inputs/button/primaryButton'
import Footer from '@components/footer'
import InsurerLogo from '@components/insurerLogo'
import Title from '@components/text/title'
import SecondaryButton from '@components/inputs/button/secondaryButton'

import { Container, GreenContainer } from '../../styles'
import { LogoContainer, CardContainer, FooterContainer } from '../styles'
import { CenterContainer, LogoutIcon } from './styles'
import colors from '@settings/styleSettings'
import backgroundImage from '@assets/images/login-background.jpg'

import { clearBeneficiary as clearBeneficiaryAction } from '@stores/actions/beneficiary'
import { getReportDataByToken as getReportDataByTokenAction } from '@stores/actions/user'

import { base64ToArrayBuffer } from '@util/generalUtil'

const RelatoryOptions = ({
  clearBeneficiary, getReportDataByToken, reportDataByBeneficiary, reportDataByUser
}) => {
  const navigate = useNavigate()
  const reportData = reportDataByBeneficiary || reportDataByUser
  const {
    insurance, userId, collectionId, token
  } = useParams()
  useEffect(() => {
    if (token) {
      getReportDataByToken(decodeURIComponent(token), userId, collectionId)
    }
  }, [])
  const hasMealPlan = reportData && reportData.mealPlan?.length > 0
  // const lastCollectionYear = reportData?.lastGeneralCollection?.collectedAt?.match(/\d{4}/)?.[0]
  // const companyId = reportData?.companyId ?? reportData?.company?.id
  // const isReportBlocked = Number(companyId) === 1 && lastCollectionYear === '2026'
  useEffect(() => {
    if (!reportData && !userId) {
      navigate(`/${insurance}`)
    }
  }, [reportData])

  const goToRelatory = () => {
    const { id: beneficiaryId } = reportData
    navigate(`/${insurance}/beneficiario/report/${beneficiaryId}`)
  }

  const getMealPlan = () => {
    const localBlob = new Blob([base64ToArrayBuffer(reportData.mealPlan)], {
      type: 'application/pdf',
    })

    // Envia o evento para o Google Analytics quando o botão é clicado
    ReactGA.event({
      category: 'Botão cardápio',
      action: 'Clique',
      label: 'Botão de cardápio nutricional',
    })

    const pdfWindow = window.open()
    pdfWindow.location.href = URL.createObjectURL(localBlob)
  }

  const onExit = () => {
    clearBeneficiary()
    navigate(`/${insurance}`)
  }

  return (
    <Container
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <GreenContainer>
        <LogoContainer>
          <InsurerLogo />
        </LogoContainer>
        <CenterContainer style={{ maxHeight: 300, margin: '60px 0' }}>
          <Title style={{ color: colors.titleStrongWhite }}>
            Saúde Preventiva
          </Title>
          {/* {isReportBlocked && (
            <p
              style={{
                color: colors.titleStrongWhite,
                textAlign: 'center',
                marginTop: 20,
                fontSize: 18,
                lineHeight: 1.4,
              }}
            >
              Já estamos analisando os dados da sua coleta de 2026! Muito em breve,
              seu plano de cuidados personalizado estará disponível.
            </p>
          )} */}
          <Card style={{ minHeight: 110, marginBottom: 0 }}>
            <CardContainer>
              {/* disabled={isReportBlocked} */}
              <PrimaryButton onClick={goToRelatory}>
                Relatório de Saúde Preventiva
              </PrimaryButton>
              <PrimaryButton
                onClick={getMealPlan}
                disabled={!hasMealPlan}
              >
                Plano de refeições
              </PrimaryButton>
            </CardContainer>
          </Card>
          <SecondaryButton
            onClick={onExit}
            style={{
              color: colors.titleStrongWhite,
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LogoutIcon className="material-icons">logout</LogoutIcon>
            Fazer logout
          </SecondaryButton>
        </CenterContainer>
        <FooterContainer>
          <Footer />
        </FooterContainer>
      </GreenContainer>
    </Container>
  )
}

RelatoryOptions.propTypes = {
  reportDataByBeneficiary: PropTypes.shape({
    id: PropTypes.number,
    mealPlan: PropTypes.string,
  }),
  reportDataByUser: PropTypes.shape({
    id: PropTypes.number,
    mealPlan: PropTypes.string,
  }),
  clearBeneficiary: PropTypes.func.isRequired,
  getReportDataByToken: PropTypes.func.isRequired,
}

RelatoryOptions.defaultProps = {
  reportDataByBeneficiary: null,
  reportDataByUser: null,
}

const mapStateToProps = ({ beneficiary, user }) => ({
  reportDataByBeneficiary: beneficiary.reportData,
  reportDataByUser: user.reportData
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    clearBeneficiary: clearBeneficiaryAction,
    getReportDataByToken: getReportDataByTokenAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(RelatoryOptions)
